import styled from 'styled-components';

const WhiteContainer = styled.div.attrs((props: any) => ({
  inRegister: props.inRegister
}))`
  background-color: #fff;
  padding: ${(props) => (props.inRegister ? '0px 4px' : '16px 16px')};
  border-radius: 8px;
  justify-content: flex-start;
  width: 100%;
  color: #161d1f;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export default WhiteContainer;
